module.exports = __webpack_public_path__ + "static/img/8.1f131e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/8.jpg
// module id = vbKv
// module chunks = 0